import React from 'react'
import youtube_img from './img/youtube_img.png'
import twitch_img from './img/twitch_img.png'
import mixcloud_img from './img/mixcloud_img.png'
import bark_img from './img/bark_img.png'


const Footer = () => {
    return (
        <footer className='footer'>
                {/* <a href="https://www.twitch.tv/djxturbo" target="_blank" rel="noreferrer nofollow"><img src={bark_img} alt="Bark" className="bark"></img></a> */}
                {/* <a href="https://www.twitch.tv/djxturbo" target="_blank" rel="noreferrer nofollow"><img src={mixcloud_img} alt="Mixcloud" className="twitch"></img></a> */}
                <a href="https://www.twitch.tv/djxturbo" target="_blank" rel="noreferrer nofollow"><img src={twitch_img} alt="Twitch" className="twitch"></img></a>
                <a className="youtube" href="https://www.youtube.com/@tedobrochta-ow4wd" target="_blank" rel="noreferrer nofollow"><img src={youtube_img} alt="YouTube"/></a>
        </footer>
    )
}

export default Footer;